import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import DefaultButton from '../molecules/DefaultButton';
import RowCenterButton from '../molecules/RowCenterButton';
import TransitionButton from '../molecules/TransitionButton';
import MypageReturn from '../molecules/MypageReturn';

interface Props {
  applied: boolean; // 事前審査申込登録状態（前：false、後：true）
  is_staff: boolean;
  reception_cd: string;
  reception_id: number;
  status_code: number;
  moveNextStep: () => void;
  movePrevStep: () => void;
  requestModule: () => void | boolean;
}

// KWANKGM03020_事前審査申込入力（確認）フッタボタン
const FooterPreExaminationApplicationInputConfirmation: React.FC<Props> = ({
  applied,
  is_staff,
  reception_cd,
  reception_id,
  status_code,
  moveNextStep,
  movePrevStep,
  requestModule,
}) => {
  const history = useHistory();

  /**
   * ナビゲーションと画面を完了画面に遷移
   */
  const handleClickNext = async () => {
    const result = await requestModule();

    // 正常終了か判定
    if (result) {
      // 正常終了なら事前審査受付完了画面に遷移
      moveNextStep();
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/finish`);
    }
  };

  /**
   * ナビゲーションと画面を入力画面に遷移
   */
  const handleClickPrev = () => {
    movePrevStep();
    history.push(`/reception/${reception_cd}/${reception_id}/${status_code}`);
  };
  return (
    <>
      {applied ? (
        <MypageReturn is_staff={is_staff} />
      ) : (
        <>
          <RowCenterButton>
            <DefaultButton label="次へ進む" strong={false} handleClick={handleClickNext} />
          </RowCenterButton>
          <TransitionButton label="戻る" handleClick={handleClickPrev} />
        </>
      )}
    </>
  );
};

export default memo(FooterPreExaminationApplicationInputConfirmation);
